import React, { useContext, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Envolvido from "./Envolvido";
import { BoletimContext } from "../../../../context/BoletimContext";
// import "./styles/list-envolvido.css";

function EnvolvidoList({ setEnvolvido, setModoEdicao }) {
  const { boletim, setBoletim } = useContext(BoletimContext);

  const envolvidos = useMemo(() => boletim?.envolvidos || [], [boletim]);

  const envolvidosMemo = useMemo(
    () =>
      envolvidos.map((envolvido) => (
        <Col
          key={envolvido._id || envolvido.id}
          xs={12}
          md={12}
          className="envolvido-col"
        >
          <Envolvido
            envolvido={envolvido}
            setBoletim={setBoletim}
            setEnvolvido={setEnvolvido}
            setModoEdicao={setModoEdicao}
          />
        </Col>
      )),
    [envolvidos, setBoletim, setEnvolvido, setModoEdicao]
  );

  if (envolvidos.length === 0) return null;

  return (
    <Container fluid className="envolvido-list">
      <div className="envolvido-list-header">
        <h6>Envolvidos Cadastrados</h6>
        <span>{envolvidos.length}</span>
      </div>

      <Row className="g-2">{envolvidosMemo}</Row>
    </Container>
  );
}

export default EnvolvidoList;
